export const config = {
  title: "Mi Escuadrón LLC",
  meta: {
    description:
      "Mi Escuadrón LLC offers expert residential and commercial electrical services in Austin, TX—including rewiring, lighting installation, panel upgrades, surge protection and more.",
    keywords: [
      "Austin electrician",
      "panel upgrade Austin",
      "lighting installation Austin",
      "Mi Escuadrón LLC",
      "electrical services Austin TX"
    ],
    author: "Mi Escuadrón LLC",
    canonicalUrl: "https://mybizsolutions.us/search/biz/mi-escuadron-llc"
  },
  sections: {
    header: { businessName: "Mi Escuadrón LLC" },
    sectionB: {
      heroTitle: "Mi Escuadrón LLC",
      heroSubtitle: "Professional Electrical Services in Austin, TX",
      learnAboutText: "Request a Free Estimate",
      phoneNumber: "5127842058",
      phoneLabel: "(512) 784‑2058",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1409304338/photo/electricity-and-electrical-maintenance-service-engineer-hand-holding-ac-multimeter-checking.jpg?s=612x612&w=0&k=20&c=Pj3gqobTp67aPN8l-lm6q-uT2DDnm-aeFk7Gkvmbaok=",
      cardData: [
        {
          title: "Rewiring & Panel Upgrades",
          description: "Complete rewiring and electric panel replacements."
        },
        {
          title: "Lighting & Outlets",
          description: "Fixture installation, switches, outlets and surge protection."
        },
        {
          title: "Troubleshooting & Repairs",
          description: "Electrical repairs for residential and commercial clients."
        }
      ],
      description:
        "With over 10 years of experience, Mi Escuadrón LLC provides reliable electrical solutions throughout Austin and surrounding areas, ensuring quality service and customer satisfaction."
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "Full-service electrical solutions for both homes and businesses.",
      cards: [
        {
          title: "Panel Upgrades",
          description: "Electric panel inspection and replacement.",
          imageSrc: "https://media.istockphoto.com/id/1422487363/photo/electricity-and-electrical-maintenance-service-engineer-hand-holding-ac-multimeter-checking.jpg?s=612x612&w=0&k=20&c=vfnoU-8tfc89y_F5gwMDDd5k5xpSZP0-UpFlHvjS0Q4=",
          imageAlt: "Panel Upgrade"
        },
        {
          title: "Lighting & Electrical Fixtures",
          description: "Installation and maintenance of lights and outlets.",
          imageSrc: "https://media.istockphoto.com/id/1124517056/photo/modern-kitchen-design-with-open-concept-and-bar-counter.jpg?s=612x612&w=0&k=20&c=-0RbUatuNDF71I-97EfPrZvzjT0XrO8NB3t5lWYrqyI=",
          imageAlt: "Lighting Installation"
        },
        {
          title: "Repairs & Troubleshooting",
          description: "Diagnosing and resolving electrical issues properly.",
          imageSrc: "https://media.istockphoto.com/id/177311145/photo/electrician-checking-cabling-power-line.jpg?s=612x612&w=0&k=20&c=Y5k_5vUCnJXz0U_DAcX-20r0UheJ1t8Lyl1mI4ah3TA=",
          imageAlt: "Electrical Repairs"
        }
      ],
      otherServicesTitle: "Additional Offerings",
      otherServicesList: [
        "Surge Protection",
        "Smart Home Wiring",
        "Electrical Inspections"
      ]
    },
    sectionD: {
      aboutTitle: "About Us",
      aboutImage: {
        src: "https://media.istockphoto.com/id/1345670559/photo/electrician-fixing-an-electrical-outlet-and-measuring-the-voltage.jpg?s=612x612&w=0&k=20&c=b_MLck2o0v160Xqo_xPPh-7ZqjtyXz18Jdo3CwkTVEo=",
        alt: "Mi Escuadrón Team"
      },
      aboutText: [
        "Mi Escuadrón LLC is a trusted electrical contractor with over a decade of experience serving Austin, TX and surrounding cities.",
        "We combine professional expertise with commitment to customer satisfaction—providing safe, quality electrical services."
      ]
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Mi Escuadrón LLC Logo",
      businessName: "Mi Escuadrón LLC",
      contact: {
        phone: "5127842058",
        phoneLabel: "(512) 784‑2058",
        email: "escuadronmuerte46@gmail.com",
        website: "https://mybizsolutions.us/search/biz/mi-escuadron-llc",
        address: "23207 Alicia Dr, Austin, TX 78621"
      },
      socialMedia: {}
    },
    sectionF: {
      address: "23207 Alicia Dr, Austin, TX 78621",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3456.123456789!2d-97.880!3d30.447!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8644cc0abc12345%3A0xabcdef7890!2s23207%20Alicia%20Dr%2C%20Austin%2C%20TX%2078621%2C%20USA!5e0!3m2!1sen!2sus!4v1234567890000!5m2!1sen!2sus"
    }
  }
};

export default config;
